<template>
  <div class="container">
    <!-- Contenedor centrado -->
    <div class="content-wrapper">
      <!-- Texto a la izquierda -->
      <div class="text-section">
        <h1>
          <span class="text-gray-500">BIENVENIDOS A </span><br />
          <span class="orange">CLÍNICA LA SAGRADA FAMILIA</span>
        </h1>
        <p>
          Clínica LA SAGRADA FAMILIA S.A.S es una empresa privada que presta
          Servicios de Salud a la comunidad Surcolombiana de Mediana y Alta
          complejidad, en los niveles (3) y (4), garantizando la prestación
          integral en las diferentes áreas y especialidades de manera oportuna y
          segura, con respeto, equidad y humanización en el servicio, buscando
          mejorar la calidad de vida de nuestros pacientes y sus familias.
        </p>
      </div>

      <!-- Video y lista a la derecha -->
      <div class="video-section">
        <div class="video-and-list">
          <!-- Video principal -->
          <div class="main-video">
            <iframe
              width="20%"
              height="315"
              :src="currentVideoUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>

          <!-- Lista de videos -->
          <div class="video-list">
            <div
              v-for="video in videos"
              :key="video.id"
              class="video-item"
              @click="changeVideo(video.id)"
            >
              <img
                :src="`https://img.youtube.com/vi/${video.id}/0.jpg`"
                alt="Miniatura"
              />
              <p>{{ video.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClinicaUros",
  data() {
    return {
      currentVideoId: "7-NFmQUobbw",
      videos: [
        { id: "_SmLLuQ_6Bk" },
        { id: "j0Tz5YSgDNQ" },
        { id: "DYVKTURac-8" },
        { id: "0tvfE07Yok0" },
      ],
    };
  },
  computed: {
    currentVideoUrl() {
      return `https://www.youtube.com/embed/${this.currentVideoId}?rel=0&modestbranding=1&showinfo=0`;
    },
  },
  methods: {
    changeVideo(id) {
      this.currentVideoId = id;
    },
  },
};
</script>

<style scoped>
/* Centrado general */
.container {
  display: flex;
  /* justify-content: center;  elimina esta línea */
  width: 100%; /* ocupa todo el ancho */
  padding-top: 60px;
  background-color: #fff;
}

.content-wrapper {
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: nowrap; /* Sin salto de línea */
}

/* Texto a la izquierda */
.text-section {
  margin-left: 100px;
  flex: 0 0 40%; /* Ocupa 40% fijo */
  max-width: 40%;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 0;
}

h1 {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 1rem;
}

p {
  text-align: justify;
  font-size: 20px;
  line-height: 1.6;
  color: #4a4a4a;
  margin-bottom: 0;
}

.orange {
  color: #ff6600;
  font-weight: bold;
}

.gray {
  font-weight: bold;
}

/* Video y scroll de miniaturas */
.video-section {
  margin-left: 170px;
  flex: 0 0 60%; /* Ocupa 60% fijo */
  max-width: 60%;
  padding: 10px;
  box-sizing: border-box;
}

.video-and-list {
  display: flex;
  gap: 15px;
}

/* Video principal */
.main-video {
  flex: 3;
  height: 315px; /* igual a la altura de .video-list */
  position: relative;
}

.main-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Lista de videos a la derecha del video */

.video-list {
  flex: 1;
  max-height: 315px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 150px; /* Limita el ancho para la lista */
}

.video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.video-item:hover {
  background-color: #f0f0f0;
}

.video-item img {
  width: 100%;
  border-radius: 5px;
  max-height: 80px;
  object-fit: cover;
}

.video-item p {
  text-align: center;
  font-size: 13px;
  margin-top: 5px;
  color: #333;
}
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }

  .text-section {
    margin-left: 0;
    flex: 1 1 100%;
    max-width: 100%;
    padding: 10px 5px;
  }

  .video-section {
    margin-left: 0;
    flex: 1 1 100%;
    max-width: 100%;
    padding: 10px 5px;
  }

  .video-and-list {
    flex-direction: column;
  }

  .main-video {
    width: 100%;
    flex: none;
  }

  .video-list {
    max-width: 100%;
    max-height: 150px; /* menos altura para móviles */
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
  }

  .video-item {
    flex: 0 0 auto;
    width: 120px;
  }
}
</style>
